// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 644) return "static/chunks/react-e9e961a8b5dee8c4.js";
	if (chunkId === 223) return "static/chunks/commons-de8178b23914c141.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"188":"a95216816f0dad33","428":"301cff6d23806c36","585":"a9a7ab88a707bb9b","718":"c0788ebebe5635c1","818":"c8f9b7450bf4bfe6","888":"29c042c8b7fc2bff"}[chunkId] + ".js";
};